const categoryStatusIconActive = {
  code: "check-e",
  color: "var(--nxgds-text-semantic-success-primary, #15a772)",
} as const;

const categoryStatusIconInactive = {
  code: "void",
  color: "var(--nxgds-text-semantic-error-primary, #dd415c)",
} as const;

const categoryStatusIconGameStatus = {
  code: "globe-a2",
  color: "var(--nxgds-text-semantic-info-primary, #0088ef)",
} as const;

export const categoryStatusOptions = [
  {
    value: 1,
    title: "common.status.active",
    icon: categoryStatusIconActive,
  },
  {
    value: 2,
    title: "common.status.inactive",
    icon: categoryStatusIconInactive,
  },
  {
    value: 3,
    title: "common.status.game_status",
    icon: categoryStatusIconGameStatus,
  },
];

export const categoryGamesStatusOptions = [
  {
    value: 1,
    title: "common.status.active",
    icon: categoryStatusIconActive,
  },
  {
    value: 2,
    title: "common.status.inactive",
    icon: categoryStatusIconInactive,
  },
];
